import { render } from "./UniversalForm.vue?vue&type=template&id=6a047b26"
import script from "./UniversalForm.vue?vue&type=script&lang=js"
export * from "./UniversalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__